import { Container, Typography } from '@mui/material'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { RootState } from '../../store'
import { ApplicantActionCard } from '../../components/ApplicantProcessCard/ApplicantActionCard'
import { ApplicantProcessCard } from '../../components/ApplicantProcessCard/ApplicantProcessCard'
import { LeaseOfferCard } from '../../components/LeaseOfferCard/LeaseOfferCard'
import { useLeaseOffers } from '../../hooks/useLeaseOffers'
import { useAppDispatch } from '../../hooks'
import { fetchLeasingContext } from '../../store/User/action'
import { AppRoutes } from '../../helpers/Routes'

export const ApplicantHome = () => {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const leasingContext = useSelector(
        (state: RootState) => state.user.leasingContext,
    )
    const {
        offers,
        actingId,
        getOffers,
        acceptOffer,
        declineOffer,
        getTransferOptions,
        requestTransfer,
    } = useLeaseOffers()

    useEffect(() => {
        dispatch(fetchLeasingContext())
    }, [])

    useEffect(() => {
        getOffers()
    }, [getOffers, leasingContext?.active_lead_id])

    const processStatus = leasingContext?.process_status ?? null
    const cta = processStatus?.cta ?? null
    const hasLead = Boolean(leasingContext?.active_lead_id)
    const showOffer = cta?.kind === 'review_offer' && offers.length > 0
    const showAction =
        cta != null && cta.kind !== 'review_offer' && Boolean(cta.label)

    const refreshAfterOffer = async (action: () => Promise<void>) => {
        await action()
        dispatch(fetchLeasingContext())
        getOffers()
    }

    const handleAction = () => {
        if (!cta) return
        if (cta.href) {
            window.open(cta.href, '_blank', 'noopener,noreferrer')
            return
        }
        if (cta.route === 'documents') {
            navigate(AppRoutes.documents)
            return
        }
        navigate(AppRoutes.applicant)
    }

    return (
        <Container maxWidth="md" sx={{ py: 4 }}>
            <Typography
                variant="h4"
                sx={{ fontWeight: 600, color: '#fff', mb: 3 }}
            >
                Home
            </Typography>

            {processStatus && <ApplicantProcessCard status={processStatus} />}

            {showOffer &&
                offers.map((offer) => (
                    <LeaseOfferCard
                        key={offer.id}
                        offer={offer}
                        acting={actingId === offer.id}
                        onAccept={(id) =>
                            refreshAfterOffer(() => acceptOffer(id))
                        }
                        onDecline={(id, reason) =>
                            refreshAfterOffer(() => declineOffer(id, reason))
                        }
                        onLoadTransferOptions={getTransferOptions}
                        onTransfer={(id, payload) =>
                            refreshAfterOffer(() =>
                                requestTransfer(id, payload),
                            )
                        }
                    />
                ))}

            {showAction && cta && (
                <ApplicantActionCard
                    cta={cta}
                    onClick={handleAction}
                    leaseTerms={processStatus?.lease_terms}
                />
            )}

            {!hasLead && (
                <Typography sx={{ color: '#8b949e' }}>
                    No active application was found for your account.
                </Typography>
            )}
        </Container>
    )
}
